import React from "react";
import { useNavigate } from "react-router-dom";
import "./ResidentDashboard.css";

export default function ResidentDashboard() {
  const navigate = useNavigate();
  const residentName = localStorage.getItem("residentName");
  const unitNumber = localStorage.getItem("unitNumber");
  const tower = localStorage.getItem("residentTower");

  return (
    <div className="resident-content">
      <h1 className="resident-dashboard-title">Welcome {residentName || "Resident"}</h1>
      <p className="resident-dashboard-subtitle">
        {tower ? `${tower} · ` : ""}Unit: {unitNumber || "Not provided"}
      </p>

      <div className="resident-quick-grid">
        <div className="resident-quick-card" onClick={() => navigate("/resident/notices")}>
          <h3>View Notices</h3>
          <p>See announcements published for your tower</p>
        </div>

        <div className="resident-quick-card" onClick={() => navigate("/resident/maintenance")}>
          <h3>Maintenance Requests</h3>
          <p>Report an issue and track its status</p>
        </div>

        <div className="resident-quick-card" onClick={() => navigate("/resident/rentals")}>
          <h3>My Rentals</h3>
          <p>Post or manage your rental listing</p>
        </div>

        <div className="resident-quick-card" onClick={() => navigate("/resident/profile")}>
          <h3>My Profile</h3>
          <p>View your registered details</p>
        </div>
      </div>
    </div>
  );
}